import React, { createContext, useCallback, useState } from 'react';

type TSetterFnNoArg = () => void;
type TSetterFn = (arg: number) => void;
type TGetterFn = (arg: number) => boolean;

type TTaxSummaryContext = {
  addPaymentID: TSetterFn;
  removePaymentID: TSetterFn;
  findPaymentID: TGetterFn;
  closeAllTaxSummaries: TSetterFnNoArg;
};

export const TaxSummaryContext = createContext<TTaxSummaryContext>({} as TTaxSummaryContext);

export function TaxSummaryProvider(props: {
  children: React.ReactNode;
  [x: string]: any;
}) {
  const [expandedPaymentIDs, setExpandedPaymentIDs] = useState<number[]>([]);

  const closeAllTaxSummaries = useCallback(() => {
    setExpandedPaymentIDs([]);
  }, []);

  const findPaymentID = useCallback((id: number) => 
    expandedPaymentIDs.some((e) => e === id), 
    [expandedPaymentIDs],
  );

  const addPaymentID = useCallback((id: number) => {
    setExpandedPaymentIDs((prev) => findPaymentID(id) ? prev : [...prev, id]);
  }, [findPaymentID, setExpandedPaymentIDs]);

  const removePaymentID = useCallback((id: number) => {
    setExpandedPaymentIDs((prev) => prev.filter((e) => e !== id ));
  }, [setExpandedPaymentIDs]);

  return (
    <TaxSummaryContext.Provider
      value={{
        addPaymentID,
        removePaymentID,
        findPaymentID,
        closeAllTaxSummaries,
      }}
    >
      {props.children}
    </TaxSummaryContext.Provider>
  )
}
